// extracted by mini-css-extract-plugin
export default {"defaultComboBox":"PinFrequencyControl_defaultComboBox__sat1a"};